import { render, staticRenderFns } from "./DashboardFilas.vue?vue&type=template&id=20478008&scoped=true"
import script from "./DashboardFilas.vue?vue&type=script&lang=ts"
export * from "./DashboardFilas.vue?vue&type=script&lang=ts"
import style0 from "./DashboardFilas.vue?vue&type=style&index=0&id=20478008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20478008",
  null
  
)

export default component.exports